// extracted by mini-css-extract-plugin
export default {"selected":"d60dc70b02","un":"adbe990e87"};